const styles = (theme) => ({
  alphabetWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    marginLeft: 'auto',
    paddingTop: theme.spacing(1.5),
    paddingBottom: theme.spacing(1),
    width: theme.spacing(5),
    textAlign: 'center',
    textTransform: 'capitalize',
  },
  alphabetLetter: {
    '-webkit-tap-highlight-color': 'transparent',
    position: 'relative',
    '&:focus': {
      outline: 'none',
    },
    fontSize: '1.8vh',
    color: theme.color.grey_dark,
    cursor: 'pointer',
  },
  disabledAlphabetLetter: {
    '-webkit-tap-highlight-color': 'transparent',
    '&:focus': {
      outline: 'none',
    },
    fontSize: '1.8vh',
    color: theme.color.grey_medium,
    cursor: 'pointer',
  },
  alphabetLetterActive: {
    '-webkit-tap-highlight-color': 'transparent',
    position: 'relative',
    'font-size': '1.8vh',
    '&:focus': {
      outline: 'none',
    },
    color: theme.color.green_7c,
    cursor: 'pointer',
  },
  alphabetLetterHint: {
    left: -50,
    lineHeight: '20px',
    padding: theme.spacing(1.25),
    color: theme.color.grey_e1,
    top: -10,
    background: theme.color.green_7c,
    width: 40,
    borderRadius: 20,
    height: 40,
    position: 'absolute',
  },
  letterWrapper: {},
});

export default styles;
